import React from 'react';
import styles from '../../../../css/NavigatorBar/NavigatorContents/navCautionContent.module.css';
import { ReactComponent as DotSVG } from '../../../../assets/icons/svg/dot.svg';

// 유의사항 목록을 점 리스트로 렌더링하는 컴포넌트
function navCautionContent({ ...data }) {
  const cautionData = Array.isArray(data.caution) ? data.caution : [];

  const normalizeItem = item =>
    typeof item === 'string'
      ? { text: item }
      : (item || { text: '' });

  const sublistDepthClass = {
    1: styles['caution-sublist-depth-1'],
    2: styles['caution-sublist-depth-2'],
    3: styles['caution-sublist-depth-3'],
  };
  const subitemDepthClass = {
    1: styles['caution-subitem-depth-1'],
    2: styles['caution-subitem-depth-2'],
    3: styles['caution-subitem-depth-3'],
  };

  const renderSubItems = (items, depth) => {
    if (!Array.isArray(items) || items.length === 0) return null;
    const depthClass = sublistDepthClass[depth] ?? '';
    const listClass = [styles['caution-sublist'], depthClass].filter(Boolean).join(' ');

    return (
      <ul className={listClass}>
        {items.map((rawItem, idx) => {
          const normalized = normalizeItem(rawItem);
          const subItems = Array.isArray(normalized.subItems) ? normalized.subItems : [];
          const itemDepthClass = subitemDepthClass[depth] ?? '';
          const itemClass = [styles['caution-subitem'], itemDepthClass].filter(Boolean).join(' ');

          if (normalized.type === 'note') {
            return (
              <li key={`${depth}-${idx}`} className={`${itemClass} ${styles['caution-subitem-note']}`}>
                <div className={styles['caution-subnote']}>{normalized.text}</div>
              </li>
            );
          }

          return (
            <li key={`${depth}-${idx}`} className={itemClass}>
              <div className={styles['caution-subline']}>
                <span className={styles['caution-subdash']}>-</span>
                <span>{normalized.text}</span>
              </div>
              {renderSubItems(subItems, depth + 1)}
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className={styles['caution-content-wrapper']}>
      <ul className={styles['caution-content-ul']}>
        {cautionData.map((item, i) => {
          const normalized = normalizeItem(item);
          const subItems = Array.isArray(normalized.subItems) ? normalized.subItems : [];

          return (
            <li key={i} className={styles['caution-content']}>
              <div className={styles.dotWrapper}>
                <DotSVG />
              </div>
              <div className={styles['caution-text']}>
                <div>{normalized.text}</div>
                {renderSubItems(subItems, 1)}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default navCautionContent;
